import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/assets/shared/upload-bulk.svg'


const _hoisted_1 = { class: "mb-4 flex items-center bg-blue-50 border-l-4 border-blue-400 p-4 rounded" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "flex flex-col gap-4 w-full bg-white rounded-lg p-8 shadow max-w-3xl mx-auto mt-6" }
const _hoisted_4 = { class: "text-sm text-gray-700 mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "w-full"
}
const _hoisted_6 = {
  key: 1,
  class: "w-full flex flex-col items-center justify-center border-2 border-dashed border-primary-purple rounded-lg p-8"
}
const _hoisted_7 = { class: "text-gray-700" }
const _hoisted_8 = {
  key: 2,
  class: "w-full"
}
const _hoisted_9 = { class: "flex items-center bg-gray-50 border rounded-lg p-4 mb-2 relative" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = { class: "font-medium text-gray-900" }
const _hoisted_14 = { class: "text-xs text-gray-500" }
const _hoisted_15 = { class: "text-xs text-gray-700 font-semibold" }
const _hoisted_16 = {
  key: 0,
  class: "absolute right-4 top-4 text-xs text-gray-500 flex items-center"
}
const _hoisted_17 = {
  key: 0,
  class: "bg-red-100 text-red-700 px-4 py-2 rounded mb-2 text-sm"
}
const _hoisted_18 = { class: "border border-gray-200 rounded-lg p-2 mb-4 max-h-64 overflow-y-auto" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center text-xs text-green-600 font-medium gap-1 mr-2"
}
const _hoisted_20 = { class: "text-xs text-red-500 mr-2" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "mt-4" }
const _hoisted_23 = { class: "flex justify-between items-center mb-2" }
const _hoisted_24 = { class: "flex gap-2" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 1,
  class: "flex gap-2 w-full justify-center p-2.5 text-sm text-center text-green-800 bg-green-50 rounded-lg mt-2"
}
const _hoisted_32 = {
  key: 2,
  class: "flex gap-2 w-full justify-center p-2.5 text-sm text-center text-red-900 bg-red-50 rounded-lg mt-2"
}
const _hoisted_33 = {
  key: 3,
  class: "flex gap-2 w-full justify-center p-2.5 text-sm text-center text-green-800 bg-green-50 rounded-lg mt-2"
}
const _hoisted_34 = {
  key: 4,
  class: "flex gap-2 w-full justify-center p-2.5 text-sm text-center text-red-900 bg-red-50 rounded-lg mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomMessageBox = _resolveComponent("CustomMessageBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        innerHTML: _ctx.INFO_ICON,
        class: "w-6 h-6 text-blue-400 flex-shrink-0"
      }, null, 8, _hoisted_2),
      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "ml-3 text-base text-gray-700 leading-normal" }, " To invite expert in bulk download the sample file and include email addresses in the CSV file. Upon uploading the CSV you have the option to customize the email message and decide if you want the signup link to go to your customized program landing page first or directly to the profile signup form. Upon upload you'll also see a validation step to ensure each email in the CSV is valid. After you send the invites you can check the expert status in the Experts tab. ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "text-2xl font-semibold text-neutral-900 mb-1" }, " Bulk Invite Experts ", -1)),
        _createElementVNode("p", _hoisted_4, [
          _cache[12] || (_cache[12] = _createTextVNode(" Upload a CSV file with expert emails you want to invite. ")),
          _createElementVNode("button", {
            class: "text-primary-purple underline ml-1",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadSampleCsv && _ctx.downloadSampleCsv(...args))),
            type: "button"
          }, " Download sample file ")
        ])
      ]),
      (!_ctx.fileInfo && !_ctx.isProcessing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "border-2 border-dashed border-primary-purple rounded-lg p-8 flex flex-col items-center justify-center cursor-pointer hover:bg-purple-50 transition",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args))),
              onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"])),
              onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("input", {
                ref: "fileInput",
                type: "file",
                accept: ".csv,.xls,.xlsx",
                class: "hidden",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
              }, null, 544),
              _cache[14] || (_cache[14] = _createElementVNode("img", {
                src: _imports_0,
                alt: "Upload",
                class: "w-16 h-16 mb-2"
              }, null, -1)),
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "font-medium text-gray-700" }, "Select a CSV file to Upload", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-sm text-gray-500 mt-1" }, "or drag and drop", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-xs text-gray-400 mt-2" }, "Accepted: .csv, .xls, .xlsx", -1))
            ], 32)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isProcessing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[18] || (_cache[18] = _createElementVNode("svg", {
              class: "animate-spin h-10 w-10 text-primary-purple mb-2",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.processingMessage), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.fileInfo && !_ctx.isProcessing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: _ctx.fileIcon,
                alt: "file",
                class: "w-10 h-10 mr-3"
              }, null, 8, _hoisted_10),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.fileInfo.name), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.fileInfo.size), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.results.length) + " Records", 1)
                ])
              ]),
              _createElementVNode("button", {
                class: "ml-4 text-red-500 hover:text-red-700 text-sm flex items-center",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args)))
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4 mr-1",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1),
                _createTextVNode(" Remove ")
              ])),
              (_ctx.isValidating)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _cache[20] || (_cache[20] = [
                    _createElementVNode("svg", {
                      class: "animate-spin h-4 w-4 mr-1",
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      })
                    ], -1),
                    _createTextVNode(" Validation... ")
                  ])))
                : _createCommentVNode("", true)
            ]),
            (_ctx.invalidCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.invalidCount) + " record" + _toDisplayString(_ctx.invalidCount > 1 ? "s are" : " is") + " invalid in the file. ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (row, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: row.email,
                    class: "flex items-center gap-2 py-1 px-2 rounded hover:bg-gray-100"
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["flex-1 truncate", { 'text-red-600': !row.valid }])
                    }, _toDisplayString(row.email), 3),
                    (row.valid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _cache[21] || (_cache[21] = [
                          _createElementVNode("svg", {
                            class: "w-4 h-4 text-green-500",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M5 13l4 4L19 7"
                            })
                          ], -1),
                          _createTextVNode(" Valid ")
                        ])))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(row.error), 1),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.removeResult(idx)),
                            class: "text-xs text-red-500 hover:underline"
                          }, " Remove ", 8, _hoisted_21)
                        ], 64))
                  ]))
                }), 128))
              ])
            ]),
            _createVNode(_component_CustomMessageBox, {
              message: _ctx.message,
              "onUpdate:message": _cache[6] || (_cache[6] = (val) => (_ctx.message = val)),
              "label-classes": "font-bold text-base text-neutral-900 mb-1"
            }, null, 8, ["message"]),
            _createElementVNode("div", _hoisted_22, [
              _renderSlot(_ctx.$slots, "checkbox")
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "mb-4" }, null, -1)),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearResults && _ctx.clearResults(...args))),
                class: "text-sm text-gray-500 hover:text-gray-700"
              }, " Clear Results "),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args))),
                  class: "px-4 py-2 rounded border border-gray-300 text-gray-700 bg-white hover:bg-gray-100"
                }, " Cancel "),
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleSendTestEmail && _ctx.handleSendTestEmail(...args))),
                  disabled: _ctx.sendTestEmailLoading,
                  class: "px-4 py-2 rounded bg-primary-purple text-white font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                }, [
                  (!_ctx.sendTestEmailLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Send test Email to me"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_27, "Sending test email..."))
                ], 8, _hoisted_25),
                _createElementVNode("button", {
                  disabled: _ctx.validCount === 0 || _ctx.isInviting,
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.sendInvites && _ctx.sendInvites(...args))),
                  class: "px-4 py-2 rounded bg-primary-purple text-white font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                }, [
                  (_ctx.isInviting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _cache[22] || (_cache[22] = [
                        _createElementVNode("svg", {
                          class: "animate-spin h-4 w-4 mr-1 inline",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1),
                        _createTextVNode(" Inviting... ")
                      ])))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, "Invite " + _toDisplayString(_ctx.validCount) + " Member" + _toDisplayString(_ctx.validCount > 1 ? "s" : ""), 1))
                ], 8, _hoisted_28)
              ])
            ]),
            (_ctx.testEmailSuccessMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.testEmailSuccessMessage), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.testEmailErrorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.testEmailErrorMessage), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.finalMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.finalMessage), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.finalError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.finalError), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}